"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveFileImpulse = void 0;
var RemoveFileImpulse = /** @class */ (function () {
    function RemoveFileImpulse(uri) {
        this.uri = uri;
    }
    return RemoveFileImpulse;
}());
exports.RemoveFileImpulse = RemoveFileImpulse;
//# sourceMappingURL=RemoveFileImpulse.js.map